import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		// גלילה לחלק העליון של הדף כאשר הנתיב משתנה
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
};

export default ScrollToTop; 